export enum LiveClassSurveyTrackEvents {
  AI_FEEDBACK_thumb_up_submit = 'AI_FEEDBACK_thumb_up_submit',
  AI_FEEDBACK_thumb_down_click = 'AI_FEEDBACK_thumb_down_click',
  AI_FEEDBACK_thumb_down_submit = 'AI_FEEDBACK_thumb_down_submit',
  AI_FEEDBACK_learn_more = 'AI_FEEDBACK_learn_more',
}



// WEBPACK FOOTER //
// ./ts/app/teacher-feedback/teacher-liveclass-feedback-modal/liveclass-suvery-track-event.ts